<div class="overlay"
     [ngStyle]="getStyle(isHoverState, useFallbackImage)"
     (click)="onClick($event)"
     [style.opacity]="opacity"
     [style.lineHeight]="1"
     [id]="overlay.uid"
     [style.left.%]="position.x"
     [style.top.%]="position.y"
     (mouseenter)="toggleHoverState()"
     (mouseleave)="toggleHoverState()"
>
     <img
          #hiddenImage
          class="hidden-image"
          *ngIf="overlay.isPersonalized"
          [src]="overlayService.getImageUrl(overlay, useFallbackImage)"
          [alt]="overlay.altText"
     />
</div>
